import files from "../files/index";
var path = '/takenaka';
var takenaka = function (url) { return function () { return ({
    files: files(url + path)
}); }; };
export default takenaka;
